import { AnyAction } from 'redux';
import { DataSource } from 'types/entities.types';
import { FETCH_DATA_SOURCES_SUCCESS, UPDATE_ID_TOKEN, SAVE_DATA_SELECTED_ASSET } from '../actions/actionTypes';

export interface AppState {
  tokenUpdateCounter: number;
  selectedAsset: {
    dataSourceName: string;
    externalUrl: string;
    assetId: string;
    databricksHost: string;
  };
  dataSources: DataSource[];
}

const initialState: AppState = {
  tokenUpdateCounter: 0,
  selectedAsset: {
    dataSourceName: '',
    externalUrl: '',
    assetId: '',
    databricksHost: '',
  },
  dataSources: [],
};

export function appReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case UPDATE_ID_TOKEN:
      return {
        ...state,
        tokenUpdateCounter: state.tokenUpdateCounter + 1,
      };

    case FETCH_DATA_SOURCES_SUCCESS:
      return {
        ...state,
        dataSources: [...action.dataSources],
      };

    case SAVE_DATA_SELECTED_ASSET:
      return {
        ...state,
        selectedAsset: {
          dataSourceName: action.dataSourceName,
          externalUrl: action.externalUrl,
          assetId: action.assetId,
          databricksHost: action.databricksHost,
        },
      };

    default:
      return state;
  }
}
